import create from "zustand";
import { SetState } from "zustand";

import { SurveyModel, SurveyQuestionJson } from "@performyard/service-contracts";

import { SurveyDetailsModal, SurveyDetailsStore } from "./model";

const surveyDetailsStore = (set: SetState<SurveyDetailsStore>) => ({
	surveyStatus: null as SurveyModel["status"] | null,
	modal: null,
	validQuestions: [],
	validName: "",
	surveyLink: "",
	setters: {
		setSurveyStatus: (surveyStatus: SurveyModel["status"] | null) => set({ surveyStatus }),
		setModal: (modal: SurveyDetailsModal | null) => set({ modal }),
		setValidQuestions: (validQuestions: SurveyQuestionJson[]) => set({ validQuestions }),
		setValidName: (validName: string) => set({ validName }),
		setSurveyLink: (surveyLink: string) => set({ surveyLink }),
	},
});

export const useSurveyDetailsStore = create<SurveyDetailsStore>(surveyDetailsStore);

export const useSurveyStatus = () => useSurveyDetailsStore((state) => state.surveyStatus);
export const useModal = () => useSurveyDetailsStore((state) => state.modal);
export const useValidQuestions = () => useSurveyDetailsStore((state) => state.validQuestions);
export const useValidName = () => useSurveyDetailsStore((state) => state.validName);
export const useSurveyLink = () => useSurveyDetailsStore((state) => state.surveyLink);

export const useSetters = () => useSurveyDetailsStore((state) => state.setters);
